import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'messages',
  initialState: {
    messages: {},
    messagesCount: 0,
  },
  reducers: {
    setMessagesCountBeforeHidingUI: (state) => {
      state.messagesCountBeforeHidingUI = state.messagesCount
    }
  },
})

export const {
  setMessagesCountBeforeHidingUI
} = slice.actions

export default slice.reducer
